import { RootState } from "store";

const selectHoveredTimeBlock = (state: RootState) =>
  state.hoveredLegend.hoveredTimeBlock;

export default selectHoveredTimeBlock;
